// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__35Yok","title":"Header_title__1-0Aa","left":"Header_left__35Mr8","clinicName":"Header_clinicName__1v_6z"};